import React from "react";
import { useAppSelector } from "../../../store/hooks";
import type { SitelineEntry } from "../types";

const norm = (s?: string) => (s || "").toLowerCase();

type Item = { key: string; icon: string; label: string; done: string };
const ITEMS: Item[] = [
  { key: "aotd", icon: "🎨", label: "aotd", done: "🏆 won" },
  { key: "coffee", icon: "☕", label: "coffee", done: "rated" },
  { key: "card", icon: "🃏", label: "cards", done: "pulled" },
  { key: "recipe", icon: "🍳", label: "recipe", done: "made" },
  { key: "gallery", icon: "🖼️", label: "gallery", done: "added" },
];

/** Compact "what you did today" strip — derived from the feed entries that are
 *  yours and dated today. Only shown to a logged-in user. */
const SitelineTodayStrip: React.FC<{ entries: SitelineEntry[] }> = ({ entries }) => {
  const username = useAppSelector((s) => s.auth?.username);
  if (!username) return null;
  const me = norm(username);

  const t0 = (() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d.getTime(); })();
  const mineToday = entries.filter((e) => norm(e.actor?.username) === me && e.occurredAt >= t0);
  const count = (k: string) => mineToday.filter((e) => e.kind === k).length;

  return (
    <div className="today-strip">
      <span className="today-label">your day</span>
      <div className="today-items">
        {ITEMS.map((it) => {
          const n = count(it.key);
          const done = n > 0;
          return (
            <div key={it.key} className={"today-chip" + (done ? " is-done" : "")} title={it.label}>
              <span className="today-emoji">{it.icon}</span>
              <span className="today-text">{done ? it.done : it.label}</span>
              {done && n > 1 && <span className="today-badge">×{n}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SitelineTodayStrip;
